import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { ToolsPanelButton } from "../../../screens/positions-and-orders/controls";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ReactEcharts from "echarts-for-react";

export function ResetPortfolioZoomButton() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();

    const handle = async (): Promise<void> => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.balanceStartValueX = null;
            selectedPortfolio.portfolioSettings.balanceEndValueX = null;
            selectedPortfolio.portfolioSettings.balanceStartValueY = null;
            selectedPortfolio.portfolioSettings.balanceEndValueY = null;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    };

    return (
        <ToolsPanelButton
            tooltipText="Reset zoom"
            disabled={false}
            onChanged={handle}
        >
            <ZoomOutMapIcon sx={{
                height: '18px',
                width: '18px',
            }}/>
        </ToolsPanelButton>
    );
}